import { forEach } from 'lodash';

import API from '~config/api';
import {
  ApiPromise,
  DataResponse,
  ErrorResponse,
  FileObj,
} from '~globals/types';

import { Driver, DriverCreateBody, DriverImporter } from './types';

export const ADMIN_DRIVER_ENPOINTS = {
  sendAdminDriverInvitation: '/api/v1/Admin/Driver/SendInvitation',
  createDriver: '/api/v1/Admin/User',
  getTemplateCSV: '/api/v1/Admin/Driver/ImportFromCSV/Template',
  importDriversByCSV: '/api/v1/Admin/Driver/ImportFromCSV',
};

export const sendAdminDriverInvitation = (
  email: string,
): ApiPromise<DataResponse<null>, ErrorResponse> =>
  API.post<DataResponse<null>, ErrorResponse>(
    ADMIN_DRIVER_ENPOINTS.sendAdminDriverInvitation,
    { email },
  );

export const createDriver = (
  body: DriverCreateBody,
): ApiPromise<DataResponse<Driver>, ErrorResponse> =>
  API.post<DataResponse<Driver>, ErrorResponse>(
    ADMIN_DRIVER_ENPOINTS.createDriver,
    body,
  );

export const importDriversByCSV = (
  files: FileObj[],
): ApiPromise<DataResponse<DriverImporter>, ErrorResponse> => {
  const formData = new FormData();

  forEach(files, (item) => {
    formData.append('formFile', item.file, item.file.name);
  });

  return API.post<DataResponse<DriverImporter>, ErrorResponse>(
    ADMIN_DRIVER_ENPOINTS.importDriversByCSV,
    formData,
    {
      headers: {
        'Content-Type': 'multipart/form-data',
        Accept: 'multipart/form-data',
      },
    },
  );
};
